import { getMomentDate } from "../utils/commonUtils";
import { TRANSLATE_LANGUAGE } from "../constants/Define";
import {toArray, find} from 'lodash';
import i18n from '../constants/initLng';
export default class Translation {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.__keys__ = Object.keys(data);
        this.__keys__.forEach(key => {
            this[key] = data[key] !== undefined && data[key] !== null ? data[key] : undefined;
        });
        this.id = data.id || undefined;
        this.languageCode = data.languageCode || undefined;
        this.setLanguage(data)
        this.isDefault = data.isDefault !== undefined && data.isDefault !== null ? data.isDefault : false;
        this.createdDate = getMomentDate(data.createdDate);
    }

    setLanguage(data={}){
        const langEnum = find(toArray(TRANSLATE_LANGUAGE), lang => lang.code === data.languageCode)
        this.languageName = langEnum && i18n.t(`translate.languages.${langEnum.id}`);
    }

    export() {
        const result = {};
        this.__keys__.forEach(key => {
            result[key] = this[key] !== undefined && this[key] !== null ? this[key] : undefined;
        });
        return {
            ...result,
            id: this.id,
            languageCode: this.languageCode,
            isDefault: this.isDefault,
            createdDate: this.createdDate && this.createdDate.toISOString(),
        }
    }
}